import React from 'react';
import { connect } from 'react-redux';

export default class RightPanelBottomwebsiteButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      waitingArea: props.waitingAreaForm,
      websiteButtonDetails: props.waitingArea ? props.waitingArea.websiteButtonDetails : undefined,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({
      waitingArea: props.waitingArea,
      websiteButtonDetails: props.waitingArea ? props.waitingArea.websiteButtonDetails : undefined,
    });
  }

  render() {
    var orgWaitingAreas = '';
    return (
      <div className=" ui segment ignored info attached message  borderless  max-width brdr-radius-null mrbl">
        <h3 className="ui header">
          <i className="ui circle info icon" />{' '}
        </h3>
        <div className="mrbs">
          <h5 className="mrtm span-like color-black"> {APP.LANGUAGE.WaitingAreaWebsiteButton.WaitingAreasLabel}</h5>
        </div>
        <span className="span-like  color-black">{this.props.waitingArea.name}</span>
      </div>
    );
  }
}
